import { Router } from '@angular/router';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UrlContant } from 'src/app/constants/router.contant';
import { AuthenticationService } from 'src/app/public-module/services/authentication.service';
import { SharedService } from 'src/app/public-module/services/shared.service';

@Component({
  selector: 'app-social-logins',
  templateUrl: './social-logins.component.html',
  styleUrls: ['./social-logins.component.scss'],
})
export class SocialLoginsComponent implements OnInit {
  @ViewChild('loginRef', { static: true }) loginElement: ElementRef;
  @Input() userType = '';

  auth2: any;

  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.googleSDK();
    this.fbLibrary();
  }

  googleSDK() {
    window['googleSDKLoaded'] = () => {
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          client_id:
            '26476817068-d3dq23gd82fjk950uklafm00esa89svd.apps.googleusercontent.com',
          cookiepolicy: 'http://localhost:4200/', //'single_host_origin',
          scope: 'profile email',
        });
        this.prepareLoginButton();
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'google-jssdk');
  }

  prepareLoginButton() {
    this.auth2.attachClickHandler(
      this.loginElement.nativeElement,
      {},
      (googleUser) => {
        let profile = googleUser.getBasicProfile();
        // console.log('Token || ' + googleUser.getAuthResponse().id_token);
        // console.log('ID: ' + profile.getId());
        // console.log('Name: ' + profile.getName());
        // console.log('Image URL: ' + profile.getImageUrl());
        // console.log('Email: ' + profile.getEmail());
        // console.log('profile: ' + JSON.stringify(profile));

        // Api call here.....
        const formData: any = new FormData();
        formData.append('token', googleUser.getAuthResponse().id_token);
        formData.append('userType', this.userType);

        this._authenticationService.socialGoogleAuthPostApi(formData).subscribe(
          (res: any) => {
            if (res && res['role']) {
              res['role'] = res['role'];
              this._sharedService.setLoginStatus(true);
              this._sharedService.setLoggedInUserData(res);
              this._sharedService.setUserRole(res['role']);
              this._sharedService.setToken(res.token);
              this._sharedService.onShowMessageBar(
                'Facebook auth login successfully'
              );
              if (res['role']) {
                this.onRedirectDashboard(res);
              } else {
                this._router.navigate(['/' + UrlContant.HOME_URL]);
              }
              const date = new Date();
              this._sharedService.setTimeStamp(date);
            } else {
              this._sharedService.onShowMessageBar(res.message);
            }
          },

          (err) => {
            this._sharedService.onShowMessageBar(err.error.message);
          }
        );
      }
    );
  }

  onRedirectDashboard(response: any) {
    switch (this.userType) {
      case 'user':
        this._sharedService.setUserDetails(response);
        this._router.navigate(['/' + UrlContant.USER_PROFILE]);
        break;

      case 'temple':
        this._sharedService.setTempleDetails(response);
        this._router.navigate(['/' + UrlContant.TEMPLE_PROFILE_INFO]);
        break;

      case 'crematorium':
        this._sharedService.setCrematoriumDetails(response);
        this._router.navigate(['/' + UrlContant.CREMATORIUM_PROFILE_INFO]);
        break;

      case 'florist':
        this._sharedService.setFloristDetails(response);
        this._router.navigate(['/' + UrlContant.FLORIST_PROFILE_INFO]);
        break;

      case 'pandit':
        this._sharedService.setPanditDetails(response);
        this._router.navigate(['/' + UrlContant.PANDIT_LIST]);
        break;

      default:
        this._sharedService.setUserDetails(response);
        this._router.navigate(['/' + UrlContant.HOME_URL]);
        break;
    }
  }

  fbLibrary() {
    (window as any).fbAsyncInit = function () {
      window['FB'].init({
        appId: '4779291208787028',
        cookie: true,
        xfbml: true,
        version: 'v3.1',
      });
      window['FB'].AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  login() {
    window['FB'].login(
      (response) => {
        console.log('login response', response);
        if (response.authResponse) {
          window['FB'].api(
            '/me',
            {
              fields: 'last_name, first_name, email',
            },
            (userInfo) => {
              console.log('user information');
              console.log(userInfo);
              const formData: any = new FormData();
              formData.append('acc_token', response.authResponse.accessToken);
              formData.append('user_type', this.userType);

              this._authenticationService
                .socialFacebookAuthPostApi(formData)
                .subscribe(
                  (res: any) => {
                    if (res && res['role']) {
                      res['role'] = res['role'];
                      this._sharedService.setLoginStatus(true);
                      this._sharedService.setLoggedInUserData(res);
                      this._sharedService.setUserRole(res['role']);
                      this._sharedService.setToken(res.token);
                      this._sharedService.onShowMessageBar(
                        'Facebook auth login successfully'
                      );
                      if (res['role']) {
                        this.onRedirectDashboard(res);
                      } else {
                        this._router.navigate(['/' + UrlContant.HOME_URL]);
                      }
                      const date = new Date();
                      this._sharedService.setTimeStamp(date);
                    } else {
                      this._sharedService.onShowMessageBar(res.message);
                    }
                  },

                  (err) => {
                    this._sharedService.onShowMessageBar(err.error.message);
                  }
                );
            }
          );
        } else {
          this._sharedService.onShowMessageBar('User login failed');
        }
      },
      { scope: 'email' }
    );
  }
}
